// src/components/UI/LoadingSkeletons.tsx
import React from 'react';

/**
 * Loading skeleton component for route transitions
 * Provides visual feedback while route chunks are loading
 */
export const RouteLoadingSkeleton: React.FC = () => {
  return (
    <div className="loading-skeleton-container" style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: '20px',
      backgroundColor: 'var(--background-color)',
      gap: '15px'
    }}>
      {/* Header skeleton */}
      <div className="loading-skeleton" style={{
        height: '60px',
        borderRadius: '8px',
        width: '100%'
      }} />

      {/* Content skeletons */}
      <div style={{
        display: 'flex',
        gap: '15px',
        height: 'calc(100% - 75px)'
      }}>
        {/* Sidebar skeleton */}
        <div className="loading-skeleton" style={{
          width: '300px',
          borderRadius: '8px',
          flexShrink: 0
        }} />

        {/* Main content skeleton */}
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '15px'
        }}>
          <div className="loading-skeleton" style={{
            height: '200px',
            borderRadius: '8px'
          }} />
          <div className="loading-skeleton" style={{
            height: '100%',
            borderRadius: '8px'
          }} />
        </div>
      </div>
    </div>
  );
};

/**
 * Minimal loading fallback for smaller components
 */
export const ComponentLoadingSkeleton: React.FC = () => {
  return (
    <div className="loading-skeleton" style={{
      height: '400px',
      borderRadius: '8px',
      margin: '20px'
    }} />
  );
};

export default RouteLoadingSkeleton;
